var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex",attrs:{"id":"content"}},[(_vm.$auth.ready())?_c(_vm.layout,{tag:"component"},[_c('router-view',{key:_vm.$route.fullPath})],1):_vm._e(),_vm._v(" "),_c('vue-progress-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }